import { useState } from 'react';

export default function useTicketForm(initialValues = {}) {
  const [form, setForm] = useState({
    subject: '',
    description: '',
    priority: 'Low',
    status: 'Open',
    attachments: [],
    ...initialValues,
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({
      ...prev,
      attachments: e.target.files,
    }));
  };

  const resetForm = () => {
    setForm({
      subject: '',
      description: '',
      priority: 'Low',
      status: 'Open',
      attachments: [],
    });
    setError('');
    setSuccess('');
  };

  const toFormData = () => {
    const data = new FormData();
    data.append('subject', form.subject);
    data.append('description', form.description);
    data.append('priority', form.priority);
    data.append('status', form.status);
    for (let file of form.attachments) {
      data.append('attachments', file);
    }
    return data;
  };

  return {
    form,
    setForm,
    error,
    setError,
    success,
    setSuccess,
    handleChange,
    handleFileChange,
    resetForm,
    toFormData,
  };
}
